import React, { Component } from "react";
import { dp } from "../../../utils/shared.js";
import shared from "../../../utils/shared.js";
import { switchModule, setOptions } from "../../../actions/display";
import { connect } from "react-redux";
import _ from "lodash";

class MenuOmaha extends Component {
  constructor(props) {
    super(props);
    this._goHomeRef = null;
    this._navRefs = [];

    this.state = {
      initializedRefs: false
    };
  }

  componentDidMount() {
    this.initializeNavRefs();
    if (this._goHomeRef) {
      this._goHomeRef.addEventListener("click", () => this.props.navRoute("/omaha/nav", null));
    }
  }

  handleNav = (route) => {
    this.props.switchModule(route.module.id);
    this.props.navRoute(route.navLocation, route.module);
  };

  initializeNavRefs = () => {
    if (this.state.initializedRefs === false) {
      for (let a = 0; a < this._navRefs.length; a++) {
        this._navRefs[a].el.addEventListener("click", () => this.handleNav(this._navRefs[a].data));
      }
      this.setState({
        initializedRefs: true
      });
    }
  };

  getItems = () => {
    let items = [];
    let location = [];
    let modules = [];
    let activeModules = _.filter(this.props.content.dm_active, function (dm) {
      return dm.module_contents.in_navigation;
    });
    const currentModuleId = this.props.active_module;

    items = activeModules.map((row, i) => {
      let active = false;
      if (currentModuleId === row.id) {
        active = true;
      }

      const folderId = _.get(row, "contents.folder", null);

      if (folderId !== null) {
        const childStories = this.props.content.folder_modules.filter(
          (fm) => fm.folder === Number(folderId) && fm.model === "story"
        );
        const childStoryCategories = this.props.content.story_categories.filter(
          (sc) => sc.parent_category === Number(folderId)
        );
        const totalItems = childStories.length + childStoryCategories.length;
        if (totalItems === 1) {
          if (childStories.length === 1) {
            location[i] = "/omaha/story?id=" + childStories[0].id;
          } else {
            location[i] = "/omaha/recognition_list";
          }
        } else if (totalItems > 1) {
          location[i] = "/omaha/stories";
        }
        modules[i] = row;
      }

      let buttonStyle = {
        width: "5.76vh",
        height: "5.5vh",
        float: "left"
      };

      buttonStyle["backgroundColor"] = "#8c827a";
      if (active) {
        buttonStyle["backgroundColor"] = "#7a6e66";
        buttonStyle["transform"] = "scale(1.15, 1.15) translate(0, -0.364583333vh)";
        if (i !== 0) {
          buttonStyle["marginLeft"] = "0.416666667vh";
        }
      }

      return (
        <div
          ref={(el) =>
            (this._navRefs[i] = {
              el: el,
              data: { navLocation: location[i], module: modules[i], active: active }
            })
          }
          key={i}
          style={{ ...buttonStyle }}
        >
          <div style={{ display: "block" }}>
            <img
              style={{ maxWidth: "90%", marginTop: "0.27vh" }}
              src={dp(this.props.screen, row.module_contents.icon)}
              alt=""
            />
          </div>
          <div style={{ display: "block", fontSize: "0.78vh", marginTop: "-0.27vh" }}>
            <span>{row.name.toUpperCase()}</span>
          </div>
        </div>
      );
    });

    return items;
  };

  render() {
    let items = this.getItems();

    return (
      <div style={{ backgroundColor: "#b5ada5", height: "5.5vh", width: "100%", position: "absolute", bottom: "0vh" }}>
        <div ref={(el) => (this._goHomeRef = el)} style={{ width: "5.5vh", float: "left", paddingTop: "1vh" }}>
          <img
            style={{ height: "3.5vh" }}
            src={dp(this.props.screen, null, { path: "/img/ui/", file_name: "handicon-03.png" })}
            alt=""
          />
        </div>
        <div style={{ width: "53.73vh" }}>{items}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let active_module = state.active_module;
  let idle = shared.parseStringParam(window.location.href, "idle");
  let namedmodule = shared.parseStringParam(window.location.href, "name");

  let idleActive = true;
  if (state.content.idle_delay === 0 || idle === "false") {
    idleActive = false;
  }

  if (namedmodule) {
    active_module = _.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
  }

  return {
    active_module: active_module,
    content: state.content,
    contentHasErrored: state.contentHasErrored,
    contentIsLoading: state.contentIsLoading,
    donors: state.donors,
    donorsHasErrored: state.donorsHasErrored,
    donorsIsLoading: state.donorsIsLoading,
    screen: state.screen,
    options: state.options,
    screensNumber: state.screensNumber,
    idleActive: idleActive
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchModule: (id) => dispatch(switchModule(id)),
    setOptions: (data) => dispatch(setOptions(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuOmaha);



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/MenuOmaha.jsx